export const loadImage = function(src, callback) {
  var image = new Image();
  image.onload = function () {
    callback();
  }
  image.onerror = function () {
     console.error("Cannot load image: " + src);
     callback();
  }
  image.src = src;
  if (image.complete) {
    callback();
  }
}

export const loadVideo = function(video, callback) {
  const onLoaded = function() {
    callback();
    video.removeEventListener('loadeddata', onLoaded);
  }
  if (video.readyState === 4) {
    callback();
  } else {
    video.addEventListener('loadeddata', onLoaded, false);
  }
}

export const getParameterByName = function(name, url) { 
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const getComponentContent = function(name) {
  let filteredObj = {};
  Object.keys(window.appData).map( (key, i) => {
    const split = key.split('_');
    if (split[0] === name) {
      filteredObj[split[1]] = window.appData[key];
    }
  });
  return filteredObj;
}


// WEBPACK FOOTER //
// ./src/helpers.js